import React, { createContext, useContext } from "react";
import { BrandConfig } from "./types";


const BrandContext = createContext<
  undefined | { brands: Record<string, BrandConfig> }
>(undefined);

export const BrandProvider: React.FC<{
  currentBrand: string;
  brands: Record<string, BrandConfig>;
}> = (props) => {
  return (
    <BrandContext.Provider value={{ brands: props.brands }}>
      {props.children}
    </BrandContext.Provider>
  );
};

export const useBrandList = () => {
  const ctx = useContext(BrandContext);
  return Object.keys(ctx?.brands ?? []);
}

export const useBrand: (brand: string) => BrandConfig | undefined = (
  brand: string
) => {
  const value = useContext(BrandContext);
  return value?.brands[brand] || undefined;
};
